import { Box, Typography, Avatar } from '@mui/material';
import Logo from './../../icons/logo.svg';
import { useAccount } from '../../contexts/Account';

const Footer = () => {
  const displayYear = new Date().getFullYear();
  const { accountDetails } = useAccount();

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 3,
        mb: 1,
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 0.5,
            flexDirection: { xxs: 'column', xs: 'row' },
          }}
        >
          <Avatar
            alt={`${accountDetails.companyName} Logo`}
            src={Logo}
            sx={{
              width: { xxs: 50, xs: 32 },
              height: { xxs: 50, xs: 32 },
              mt: '-4px',
            }}
          />
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#001030',
            }}
          >
            {accountDetails.companyName} Advisory Board, Built on AdvisoryCloud
          </Typography>
        </Box>

        {/* Texto confidencial */}
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
            mb: 0.5,
          }}
        >
          Confidential Board Member Information
        </Typography>

        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
          }}
        >
          Copyright © {displayYear}, All Rights Reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
